import { useEntities } from "@app/store/entityStore";
import { Chip, type ChipProps } from "@design-system/Inputs/Chip";
import { type FC, type Ref, useMemo } from "react";

type EntityChipProps = ChipProps & {
    entityId: string;
    noEntityText?: string;
    isTrigger?: boolean;
    ref?: Ref<HTMLButtonElement>;
};

export const EntityChip: FC<EntityChipProps> = ({
    entityId,
    noEntityText,
    isTrigger = false,
    ...props
}) => {
    const { entities } = useEntities();
    const entity = useMemo(
        () => entities?.find((entity) => entity.id === entityId),
        [entities, entityId],
    );

    const value = entityId ? entity?.name : noEntityText;

    return (
        <Chip interactive={isTrigger} {...props}>
            <Chip.Icon name="building" />
            <Chip.Value>{value}</Chip.Value>
            {isTrigger && <Chip.Icon name="chevronDown" />}
        </Chip>
    );
};
